import { useSelector } from "react-redux";
import { StyledCommonForms } from "../../styled/form";
import FormikAutocomplete from "../formik/formikAutocomplete";
import FormikTextField from "../formik/formikTextField";


const NullifyForm = ({ }) => {
  const motivosAnulacion = useSelector((state) => state.forms.nullifyReasons.data);

  return <>
    <StyledCommonForms.Container>
      <StyledCommonForms.RowContainer>
        <FormikAutocomplete
          name="motivoAnulacion"
          label="Motivo de Anulación*"
          fullwidth
          options={motivosAnulacion}
          variant="standard"
        />
      </StyledCommonForms.RowContainer>
      <StyledCommonForms.RowContainer>
        <FormikTextField
          label="Observaciones"
          name="observaciones"
          fullwidth
          variant="standard"
        />
      </StyledCommonForms.RowContainer>
    </StyledCommonForms.Container>
  </>
}

export default NullifyForm;